/**
 * Stress-response mental patterns (how the body tries to protect under stress).
 */

export const MENTAL_PATTERN_ORDER = [
  "overthinking",
  "shutting_down",
  "people_pleasing",
  "staying_busy",
  "pulling_away",
  "irritability",
  "numbness",
  "hyper_independence"
];

export const MENTAL_PATTERN_LABELS = {
  overthinking: "Overthinking",
  shutting_down: "Shutting down",
  people_pleasing: "People-pleasing",
  staying_busy: "Staying busy",
  pulling_away: "Pulling away",
  irritability: "Irritability",
  numbness: "Numbness",
  hyper_independence: "Hyper independence"
};

export const MENTAL_PATTERN_INTENT = {
  overthinking: "Create control",
  shutting_down: "Reduce overwhelm",
  people_pleasing: "Maintain connection",
  staying_busy: "Avoid discomfort",
  pulling_away: "Protect from hurt",
  irritability: "Release pressure",
  numbness: "Block intensity",
  hyper_independence: "Stay self-protected"
};

export const MENTAL_PATTERN_HELP = {
  overthinking: "Slow the body, not just the mind (long exhales, grounding your feet, unclenching your jaw).",
  shutting_down: "Gentle re-engagement (humming, box breathing, stretching, or noticing 3 things around you).",
  people_pleasing: "Pause before saying yes (check: do I actually have the energy, time, or capacity for this?).",
  staying_busy: "Create intentional pauses (sit without your phone, notice your breathing, let your body feel).",
  pulling_away: "Reconnect in low-pressure ways (reply to one message, brief eye contact, sit near someone safe).",
  irritability: "Discharge stress physically (walk, shake out, step away from noise or screens for a few minutes).",
  numbness: "Reconnect through sensation (hold something cold, smell something strong like coffee or essential oils).",
  hyper_independence:
    "Practice receiving in small ways (ask for help, let someone support you, accept care without explaining)."
};

export const MENTAL_PATTERN_COLORS = {
  overthinking: "#8b7355",
  shutting_down: "#6b5b4f",
  people_pleasing: "#a67c52",
  staying_busy: "#9a8b6e",
  pulling_away: "#7d6e83",
  irritability: "#b45309",
  numbness: "#78716c",
  hyper_independence: "#5c4d3c"
};

export const UNDER_STRESS_EMOTIONS = new Set([
  "Overwhelmed",
  "Anxious",
  "Frustrated",
  "Angry",
  "Fearful",
  "Confused",
  "Skeptical",
  "Insecure",
  "Lonely",
  "Hostile",
  "Hurt",
  "Ashamed",
  "Guilty",
  "Sad",
  "Indifferent",
  "Stressed",
  "Rage",
  "Furious",
  "Irritated",
  "Vulnerable",
  "Isolated",
  "Miserable",
  "Depressed"
]);
